import { RootState } from '../../redux/store';
import { ILocationsState } from './LocationsState';

export const selectLocationsState = (state: RootState): ILocationsState => state.menuBuilder.locationPicker;
